export enum WidgetConfigType {
    WidgetConfig = 100,
    DataFilter = 200,
}
